import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { consumeAuthReturnPath, getSafeSessionStorage } from '../config/authReturn';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const provider = urlParams.get('provider');
        const error = urlParams.get('error');

        if (token || provider || error) {
          window.history.replaceState({}, document.title, '/auth/callback');
        }

        if (error) {
          console.error('Authentication error:', error);
          navigate('/?error=auth_failed', { replace: true });
          return;
        }

        if (token && provider) {
          try {
            const response = await fetch('/api/auth/consume-token', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ token })
            });
            const result = await response.json();
            const userData = result.user;

            if (response.ok && result.success && userData?.id) {
              setUserData(userData);

              const returnPath = consumeAuthReturnPath(getSafeSessionStorage(window)) || '/create-story';
              navigate(returnPath, { replace: true });
            } else {
              console.error('Invalid user data received', response.status);
              navigate('/?error=invalid_user_data', { replace: true });
            }
          } catch (decodeError) {
            console.error('Error verifying auth token:', decodeError);
            navigate('/?error=auth_verify_failed', { replace: true });
          }
        } else {
          console.error('Missing token or provider');
          navigate('/?error=missing_params', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/?error=callback_failed', { replace: true });
      }
    };

    handleAuthCallback();
  }, [navigate, setUserData]);

  return (
    <div className="auth-callback">
      <div className="container">
        <div className="loading-message">
          <h2>{t('authCallback.title')}</h2>
          <p>{t('authCallback.message')}</p>
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
